import CustomTable from "@UI/CustomTable/CustomTable"
import { useCollectionEditTable } from "./hooks/useCollectionEditTable"
import EditableRowTable from "./components/EditableRowTable/EditableRowTable"
import EditableCellTable from "./components/EditableCellTable/EditableCellTable"
import { ReactComponent as RestoreSpaceIcon } from "./assets/restoreIcon.svg"
import { Button } from "antd"
import './styles.css'
import { useMemo } from "react"

const CollectionEditTableMain = () => {
    const {
        chargeDebtorsData,
        columns,
        cleanTable,
        currentPage,
        handleChangeTale,
        handleRestoreTable } = useCollectionEditTable()

    const dataTable = useMemo(() =>
        chargeDebtorsData.dataSource?.sort((a, b) => a?.debtor_name?.localeCompare(b?.debtor_name)
        ), [chargeDebtorsData.dataSource])

    return (
        <div style={{ width: '100%', position: 'relative' }}>
            {cleanTable ? <div className='restore-table-overlay' >
                <Button
                    className='table-restore-btn'
                    icon={<RestoreSpaceIcon />}
                    type='text'
                    shape='round'
                    onClick={() => handleRestoreTable()}
                >
                    REVERTIR
                </Button>
            </div> : null}
            <CustomTable
                className="custom-table-variant-1"
                scrollSize={{
                    x: 1000,
                    y: 350
                }}
                components={{
                    body: {
                        row: EditableRowTable,
                        cell: EditableCellTable
                    }
                }}
                onChange={handleChangeTale}
                columns={columns}
                dataSource={dataTable}
                pagination={{
                    pageSize: 10,
                    total: chargeDebtorsData.dataSource.length,
                    defaulPageSize: 10,
                    current: currentPage,
                    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total}`,
                    position: ["bottomRight"]
                }}
            />
        </div>
    )
}

export default CollectionEditTableMain
